import { Select } from 'antd';
import { useState } from 'react';
import {
  companyApproval,
  companyInternalApproval,
  companyUnbind,
} from '../../../api';
import { messageError } from '../../../components/message';
import { ModalWrap } from '../../../components/modal-wrap';
import { strToJson } from '../../../lib';
import getFormatMessage from '../../../locales/get-format-message';
import { CompanyType } from '../../../model';
import {
  CommonStatusStep,
  IAPICompanyFullInfo,
  StudioCertifiedType,
} from '../../../model/api-modules';
import styles from './index.module.scss';

interface IProps {
  companyInfo: IAPICompanyFullInfo;
  onOk: () => void;
  onCancel: () => void;
}

export const ResolveModal = (props: IProps) => {
  const { companyInfo, onOk, onCancel } = props;
  const [companyType, setCompanyType] = useState<CompanyType>();

  return (
    <ModalWrap
      title="审核通过确认"
      oKText={getFormatMessage('submit')}
      cancelText={getFormatMessage('cancel')}
      onOk={async () => {
        if (
          !companyType &&
          companyInfo.certifiedType === StudioCertifiedType.Company
        ) {
          messageError('请选择身份');
          return false;
        }
        const mdmCertInfo = strToJson<{ customerId: string }>(
          companyInfo.MDMCertificationInfo
        );
        if (mdmCertInfo?.customerId) {
          await companyUnbind(companyInfo.StudioID);
        }

        const params = {
          status: CommonStatusStep.Resolve,
          companyType,
          rejectReason: '',
        };

        let res = false;
        if (companyInfo.certifiedType === StudioCertifiedType.Company) {
          res = await companyApproval(companyInfo.StudioID, params);
        } else {
          res = await companyInternalApproval(companyInfo.StudioID, params);
        }

        if (res) {
          onOk();
          return true;
        }

        messageError('操作失败');
        return false;
      }}
      onClose={onCancel}
    >
      {companyInfo.certifiedType === StudioCertifiedType.InternalKpiCode ? (
        <span>{'确认通过审核?'}</span>
      ) : (
        <div className={styles.modalContent}>
          <label>该合作伙伴身份为:</label>
          <Select
            style={{ width: 120 }}
            options={[
              { label: '自研', value: CompanyType.SelfDeveloped },
              { label: '二方', value: CompanyType.SecondParty },
              { label: '投后', value: CompanyType.PostInvestment },
            ]}
            onChange={(value) => {
              setCompanyType(value);
            }}
          />
        </div>
      )}
    </ModalWrap>
  );
};
